module.exports = __webpack_public_path__ + "media/images/landing/dno/product-4-c5a8e6002b119c6757e7b6763d75343e.png";